export default "<div class=\"text-wrap inco\" #textAnimation>\n    <div *ngFor=\"let letter of textArr\">{{letter}}</div>\n</div>"